import axiosRest from '@aponder.top/axios-rest'

const baseURL = process.env.VUE_APP_PYTHON_API_URL

const rest = axiosRest(baseURL, {}, true)
// const GET = "GET"
const regions = rest('/regions')
const region_information = rest('/region_information')
region_information.summarize = region_information.make_plural_action('summarize')
region_information.word_clouding = region_information.make_plural_action('word_clouding')

const domains = rest('/domains')// 领域

const reports = rest('/reports')
reports.generate = reports.make_plural_action('generate')

const categories = rest('/categories')

export default {
  regions,
  region_information,
  domains,
  reports,
  categories
}
